// extracted by mini-css-extract-plugin
export default {"page":"reset-password_page__xnknk","form":"reset-password_form__rtQg+","center":"reset-password_center__-P0RG","textRow":"reset-password_textRow__1hSeN"};